// src/App.js
import React from "react";
import AppRoutes from "./routes"; // automatically loads routes/index.js

export default function App() {
  return <AppRoutes />;
}
